module.exports = __webpack_public_path__ + "img/prop-music-left.6567c704.png";